import {
  isDrawableSlot,
  type AdminProfileCardSetWithSlots,
  type AdminProfileCardSlot,
  type ProfileCardRarity,
} from '../types/profileCard';
import {
  computeEffectiveTierProbabilities,
  profileCardExchangeCoinsForRarity,
} from './profileCardRarity';

/**
 * 중복 카드 1회(1장) 환전 시 지급 코인 = 세트 구입가 × 등급 환급률.
 * @deprecated 이름 호환용 — profileCardExchangeCoinsForRarity 사용 권장
 */
export function profileCardExchangeCoins(
  setPriceCoins: number,
  rarity?: ProfileCardRarity | null
): number {
  return profileCardExchangeCoinsForRarity(setPriceCoins, rarity ?? null);
}

/**
 * 세트 내에서 등급 풀 확률 → 등급 내 균등 추첨으로 1장을 뽑는다.
 * ownedSlotIndexes에 포함된 슬롯은 후보에서 제외한다 — 중복 뽑기를 허용하려면 빈 배열([])을 넘긴다.
 * 뽑을 수 있는 슬롯이 없으면 null.
 */
export function drawRandomProfileCardSlot(
  set: AdminProfileCardSetWithSlots,
  ownedSlotIndexes: number[]
): AdminProfileCardSlot | null {
  const owned = new Set(ownedSlotIndexes);
  const candidates = set.slots.filter((s) => isDrawableSlot(s) && !owned.has(s.slotIndex));
  if (candidates.length === 0) return null;

  const slotLikes = candidates.map((s) => ({
    rarity: s.rarity,
    hasImage: true,
  }));
  const tierProb = computeEffectiveTierProbabilities(slotLikes);

  const tiersWithCards = (Object.keys(tierProb) as ProfileCardRarity[]).filter(
    (t) => tierProb[t] > 0 && candidates.some((c) => c.rarity === t)
  );
  if (tiersWithCards.length === 0) return null;

  const total = tiersWithCards.reduce((sum, t) => sum + tierProb[t], 0);
  if (total <= 0) return null;

  let r = Math.random() * total;
  let pickedTier: ProfileCardRarity = tiersWithCards[tiersWithCards.length - 1];
  for (const t of tiersWithCards) {
    if (r < tierProb[t]) {
      pickedTier = t;
      break;
    }
    r -= tierProb[t];
  }

  const inTier = candidates.filter((c) => c.rarity === pickedTier);
  if (inTier.length === 0) return null;
  return inTier[Math.floor(Math.random() * inTier.length)] ?? inTier[0];
}
